export enum ConsentType {
  // OrganizationConsents
  JCA = 'JCA', // Joint Controllership Agreement
  DPA = 'DPA', // Data Processing Agreement

  // Client Consents
  ClientDataProcessing = 'ClientDataProcessing',
  ClientDataUseInApp = 'ClientDataUseInApp',
  ClientUseOfPseudonymizedData = 'ClientUseOfPseudonymizedData',
  ClientMarketing = 'ClientMarketing',
}
